import { render, staticRenderFns } from "./scoringStandardConfig.vue?vue&type=template&id=06949ed8&scoped=true"
import script from "./scoringStandardConfig.vue?vue&type=script&lang=js"
export * from "./scoringStandardConfig.vue?vue&type=script&lang=js"
import style0 from "./scoringStandardConfig.vue?vue&type=style&index=0&id=06949ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06949ed8",
  null
  
)

export default component.exports